import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Callout, Icon } from '@node-space/ui-components'
import { usePopDownloadQuery } from 'hooks/queries/usePopDownloadQuery'

interface ProofOfPaymentButtonProps {
  externalReference?: string
  isLink?: boolean
}

export const ProofOfPaymentButton = ({
  externalReference,
  isLink = false,
}: ProofOfPaymentButtonProps) => {
  const { t } = useTranslation()
  const proofOfPaymentLink = `/payment/v2/payouts/${externalReference}/proof-of-payment`

  const {
    isFetching: isFetchingDocument,
    isError: isDocumentFetchError,
    refetch: refetchDocument,
  } = usePopDownloadQuery(proofOfPaymentLink)

  const onClickHandler = async () => {
    if (externalReference) {
      const documentData = await refetchDocument()

      if (documentData?.data) {
        const url = window.URL.createObjectURL(new Blob([documentData?.data]))
        const link = document.createElement('a')
        const fileName = `ProofOfPayment_${externalReference}.pdf`
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      }
    }
  }

  return (
    <Box>
      <Button
        testId="pop-download-button"
        {...(isLink
          ? { noPadding: true, variant: 'ghost', iconElement: <Icon name="DownloadSimple" /> }
          : { full: true })}
        loading={isFetchingDocument}
        onClick={onClickHandler}
      >
        {t('downloadProofOfPayment')}
      </Button>

      {isDocumentFetchError && (
        <Box paddingT={12}>
          <Callout variant="error">{t('downloadProofOfPaymentError')}</Callout>
        </Box>
      )}
    </Box>
  )
}
